import 'vue/jsx'

// 引入windi css
import '@/plugins/unocss'

// 导入全局的svg图标
import '@/plugins/svgIcon'

// 引入全局样式
import '@/styles/index.less'

// 引入动画
import '@/plugins/animate.css'

// 初始化多语言
import { setupI18n } from '@/plugins/vueI18n'

// 引入状态管理
import { setupStore } from '@/store'

// 全局组件
import { setupGlobCom } from '@/components'

// 引入element-plus
import { setupElementPlus } from '@/plugins/elementPlus'

// 引入 form-create
import { setupFormCreate } from '@/plugins/formCreate'

// 路由
import { setupRouter } from './router'

// 权限
import { setupPermission, setupMountedFocus } from './directives'

import { createApp } from 'vue'

import App from './App.vue'

import './permission'

import infiniteScroll from 'vue3-infinite-scroll-good'

import VueDOMPurifyHTML from 'vue-dompurify-html' // 解决v-html 的安全隐患

// 创建实例
const setupAll = async () => {
  const app = createApp(App)

  await setupI18n(app)

  setupStore(app)

  setupGlobCom(app)

  setupElementPlus(app)

  setupFormCreate(app)

  setupRouter(app)

  setupPermission(app)
  setupMountedFocus(app)

  app.use(infiniteScroll)

  app.use(VueDOMPurifyHTML)

  app.mount('#app')
}

setupAll()
